<div class="chip-button-container" [attr.data-test]="'selected-adhoc-sources'">
  <ng-container *ngIf="!!adHocSources?.length; else empty">
    <button *ngFor="let item of adHocSources" class="chip-button" mat-stroked-button color="primary"
      [attr.data-test]="'adhoc-csv'" [attr.data-testid]="getFileName(item)" 
      (click)="onSourceClick(item)" [matTooltip]="getToolTip(item)">{{ getFileName(item) }}</button>
  </ng-container>
  <ng-template #empty>
    <mat-chip class="empty chip-text-color-inherit" disabled="true">{{ 'None Found' | translate:locale.language }}</mat-chip>
  </ng-template>
</div>